import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_4 = {
  class: "tab-pane p-3 fade show active",
  id: "nav-cadastro",
  role: "tabpanel",
  "aria-labelledby": "nav-cadastro-tab",
  tabindex: "0"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_12 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_13 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_14 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_15 = {
  class: "mb-2",
  style: {"max-width":"200px"}
}
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_20 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_21 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_22 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_23 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_24 = {
  class: "mb-2",
  style: {"max-width":"160px"}
}
const _hoisted_25 = {
  class: "mb-2",
  style: {"max-width":"200px"}
}
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "row mb-2" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = {
  class: "tab-pane p-3 fade",
  id: "nav-adicionais",
  role: "tabpanel",
  "aria-labelledby": "nav-adicionais-tab",
  tabindex: "0"
}
const _hoisted_30 = {
  class: "tab-pane p-3 fade",
  id: "nav-contrato",
  role: "tabpanel",
  "aria-labelledby": "nav-contrato-tab",
  tabindex: "0"
}
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_34 = { class: "card-footer" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = { class: "col-md-8" }
const _hoisted_38 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_39 = {
  key: 1,
  class: "fw-bold text-danger"
}
const _hoisted_40 = { class: "col-md-2" }
const _hoisted_41 = { class: "mb-2" }
const _hoisted_42 = { class: "table-responsive" }
const _hoisted_43 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { class: "mb-2" }
const _hoisted_48 = { class: "text-center mb-2" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = { class: "text-danger fw-bold" }
const _hoisted_51 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_52 = { class: "table table-sm table-bordered" }

import {  onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/planosService";
import * as contratosService from "@/services/clientesContratosService";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import Editor from '@tinymce/tinymce-vue'
import PlanosItens from "./PlanosItens.vue";
import { fdata } from "@/utils/funcoes";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Cadastro',
  setup(__props) {


//vue
const route = useRoute();

  var controle = reactive({

    model: {
      nome: "",
      ativo: true,
      tipo: "Familiar",
      texto: "", // Garantir que texto está inicializado
      permiteSeguro: false,

    } as service.Plano,
    tipos: ['Familiar', 'Empresarial'] ,
    simNao: [
      { texto: 'SIM', valor: true }, 
      { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],

      erro: "",
      status: "",

      janSincronizar: false,
      contratosPlano: [] as contratosService.Contrato[],
      selecionados: {} as Record<number, boolean>,
      statusSincronizar: "",
      erroSincronizar: "",
      resultadoSincronizar: [] as contratosService.ContratoSincronizarResultadoDTO[],
  })

  onMounted(() => {
    
    console.log("buscar")
    if (route.params.id) {
      // Se houver um ID na rota, buscar os detalhes do usuário
      service.obterPorId(Number(route.params.id))
        .then(usuario => {
          controle.model = usuario;
          // Garantir que texto não seja null/undefined
          if (!controle.model.texto) {
            controle.model.texto = "";
          }
        })
        .catch(error => {
          controle.erro = `Erro ao carregar: ${error}`;
        });
    }

    setTimeout(() => {
      var el = document.getElementById("inputFocus");
      if (el) {
        el.focus();
      }
    }, 500);

  });

  async function salvar() {
    try {
      // 1. Salvar o registro primeiro
      controle.status = "Salvando...";
      controle.erro = "";
      const resultado = await service.salvar(controle.model)
       controle.status = "Salvo com sucesso!";
       setTimeout(() => {
         controle.status = "";
       }, 3000);
    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
    }

  function abrirSincronizar() {
    if (!controle.model.planoId) return;

    controle.janSincronizar = true;
    controle.resultadoSincronizar = [];
    buscarContratosPlano();
  }

  function buscarContratosPlano() {
    controle.statusSincronizar = "Buscando contratos...";
    controle.erroSincronizar = "";

    contratosService.obter({ planoId: controle.model.planoId, tamanhoPagina: 1000 })
      .then((r) => {
        controle.contratosPlano = r;
        controle.selecionados = {};
        controle.statusSincronizar = "";
      })
      .catch((error) => {
        controle.erroSincronizar = `Erro ao buscar contratos: ${error.message || error}`;
        controle.statusSincronizar = "";
      });
  }

  function marcarTodos(valor: boolean) {
    controle.contratosPlano.forEach((item) => {
      controle.selecionados[item.contratoId] = valor;
    });
  }

  function aplicarSincronizacao() {
    const ids = Object.keys(controle.selecionados)
      .filter((id) => controle.selecionados[Number(id)])
      .map((id) => Number(id));

    if (ids.length === 0) {
      controle.erroSincronizar = "Selecione ao menos um contrato!";
      return;
    }

    controle.statusSincronizar = `Aplicando em ${ids.length} contrato(s)...`;
    controle.erroSincronizar = "";
    controle.resultadoSincronizar = [];

    contratosService.sincronizarTexto(ids)
      .then((r) => {
        controle.resultadoSincronizar = r;
        controle.statusSincronizar = "";
        buscarContratosPlano();
      })
      .catch((error) => {
        controle.erroSincronizar = `Erro ao sincronizar: ${error.message || error}`;
        controle.statusSincronizar = "";
      });
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Cadastro de Planos",
      items: [ 
      { label: 'Planos', to: '/planos' }, 
      { label: 'Cadastro', to: '/planos/cadastro' } ]
    }),
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro='')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[49] || (_cache[49] = _createElementVNode("nav", null, [
              _createElementVNode("div", {
                class: "nav nav-tabs",
                id: "nav-tab",
                role: "tablist"
              }, [
                _createElementVNode("button", {
                  class: "nav-link active",
                  id: "nav-cadastro-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#nav-cadastro",
                  type: "button",
                  role: "tab",
                  "aria-controls": "nav-cadastro",
                  "aria-selected": "true"
                }, "Cadastro"),
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "nav-adicionais-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#nav-adicionais",
                  type: "button",
                  role: "tab",
                  "aria-controls": "nav-adicionais",
                  "aria-selected": "false"
                }, "Adicionais"),
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "nav-contrato-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#nav-contrato",
                  type: "button",
                  role: "tab",
                  "aria-controls": "nav-contrato",
                  "aria-selected": "false"
                }, "Contrato")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", {
                        for: "planoId",
                        class: "form-label"
                      }, "ID", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.planoId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.planoId) = $event)),
                        id: "planoId",
                        formato: 'Numero',
                        readonly: "",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", {
                        for: "nome",
                        class: "form-label obrigatorio"
                      }, "Nome", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.nome,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.nome) = $event)),
                        id: "inputFocus"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", {
                        for: "tipoId",
                        class: "form-label obrigatorio"
                      }, "Tipo", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.tipo) = $event)),
                        id: "tipoId",
                        class: "form-select form-select-sm"
                      }, [
                        _cache[29] || (_cache[29] = _createElementVNode("option", { value: null }, "- Selecione -", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).tipos, (item, idx) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: idx,
                            value: item
                          }, _toDisplayString(item), 9, _hoisted_10))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _unref(controle).model.tipo]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", {
                        for: "idadeMinima",
                        class: "form-label"
                      }, "Idade Mínima", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.idadeMinima,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.idadeMinima) = $event)),
                        id: "idadeMinima",
                        formato: 'Numero',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", {
                        for: "idadeMaxima",
                        class: "form-label"
                      }, "Idade Máxima", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.idadeMaxima,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.idadeMaxima) = $event)),
                        id: "idadeMaxima",
                        formato: 'Numero',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", {
                        for: "maximoPessoas",
                        class: "form-label"
                      }, "Máximo de Pessoas", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.maximoPessoas,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(controle).model.maximoPessoas) = $event)),
                        id: "maximoPessoas",
                        formato: 'Numero',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", {
                        for: "valor",
                        class: "form-label"
                      }, "Valor R$", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.valor,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(controle).model.valor) = $event)),
                        id: "valor",
                        formato: 'DoisDecimais',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", {
                        for: "permiteSeguro",
                        class: "form-label"
                      }, "Permite Seguro?", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(controle).model.permiteSeguro) = $event)),
                        id: "permiteSeguro",
                        class: "form-select form-select-sm"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).simNao, (tipo) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: String(tipo.valor),
                            value: tipo.valor
                          }, _toDisplayString(tipo.texto), 9, _hoisted_16))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _unref(controle).model.permiteSeguro]
                      ])
                    ]),
                    (_unref(controle).model.permiteSeguro)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[36] || (_cache[36] = _createElementVNode("label", {
                            for: "valorComSeguro",
                            class: "form-label"
                          }, "Valor com Seguro R$", -1)),
                          _createVNode(TextBox, {
                            modelValue: _unref(controle).model.valorComSeguro,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(controle).model.valorComSeguro) = $event)),
                            id: "valorComSeguro",
                            formato: 'DoisDecimais',
                            class: "text-end"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", {
                        for: "percInvestidor",
                        class: "form-label"
                      }, "Investidor %", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.percInvestidor,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(controle).model.percInvestidor) = $event)),
                        id: "percInvestidor",
                        formato: 'DoisDecimais',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", {
                        for: "percVendedor",
                        class: "form-label"
                      }, "Vendedor %", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.percVendedor,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(controle).model.percVendedor) = $event)),
                        id: "percVendedor",
                        formato: 'DoisDecimais',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", {
                        for: "percSupervisor",
                        class: "form-label"
                      }, "Supervisor %", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.percSupervisor,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(controle).model.percSupervisor) = $event)),
                        id: "percSupervisor",
                        formato: 'DoisDecimais',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[40] || (_cache[40] = _createElementVNode("label", {
                        for: "percIndicador",
                        class: "form-label"
                      }, "Indicador %", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.percIndicador,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(controle).model.percIndicador) = $event)),
                        id: "percIndicador",
                        formato: 'DoisDecimais',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", {
                        for: "percMidia",
                        class: "form-label"
                      }, "Mídia %", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.percMidia,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(controle).model.percMidia) = $event)),
                        id: "percMidia",
                        formato: 'DoisDecimais',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[42] || (_cache[42] = _createElementVNode("label", {
                        for: "percTi",
                        class: "form-label"
                      }, "TI %", -1)),
                      _createVNode(TextBox, {
                        modelValue: _unref(controle).model.percTi,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(controle).model.percTi) = $event)),
                        id: "percTi",
                        formato: 'DoisDecimais',
                        class: "text-end"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", {
                        for: "ativo",
                        class: "form-label"
                      }, "Ativo", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(controle).model.ativo) = $event)),
                        id: "ativo",
                        class: "form-select form-select-sm"
                      }, [
                        _cache[43] || (_cache[43] = _createElementVNode("option", { value: null }, "- Selecione -", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).simNao, (tipo) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: String(tipo.valor),
                            value: tipo.valor
                          }, _toDisplayString(tipo.texto), 9, _hoisted_26))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _unref(controle).model.ativo]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", {
                      for: "observacoes",
                      class: "form-label obrigatorio"
                    }, "Observações", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(controle).model.observacoes) = $event)),
                      id: "observacoes",
                      class: "form-control",
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, _unref(controle).model.observacoes]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(PlanosItens, {
                  PlanoId: _unref(controle).model.planoId
                }, null, 8, ["PlanoId"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", { class: "mb-2" }, "Variáveis disponíveis: [ASSINATURACONTRATADA] [CLIENTENOME] [CLIENTENASCIMENTO] [CLIENTECPF] [CONJUGENOME] [CONJUGECPF] [ASSINATURA] [DIA] [MES] [ANO]", -1)),
                    (_unref(controle).model.planoId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("a", {
                            class: "btn btn-sm btn-outline-primary",
                            href: "#",
                            onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (abrirSincronizar()), ["prevent"]))
                          }, [...(_cache[46] || (_cache[46] = [
                            _createElementVNode("i", { class: "fa fa-sync me-1" }, null, -1),
                            _createTextVNode(" Aplicar texto atual aos contratos deste Plano ", -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true),
                    _cache[48] || (_cache[48] = _createElementVNode("label", {
                      for: "texto",
                      class: "form-label"
                    }, "Texto do Contrato", -1)),
                    _createVNode(_unref(Editor), {
                      "api-key": "lf6zyai00yc0p00geaaq5q6b0v4l7z09sbzn2xsankgk4zi7",
                      init: {
                    height: 700,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                      alignleft aligncenter alignright alignjustify | \
                      bullist numlist outdent indent | removeformat | help'
                  },
                      modelValue: _unref(controle).model.texto,
                      "onUpdate:modelValue": [
                        _cache[20] || (_cache[20] = ($event: any) => ((_unref(controle).model.texto) = $event)),
                        _cache[21] || (_cache[21] = (value) => _unref(controle).model.texto = value)
                      ]
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (salvar()))
                }, "Gravar")
              ]),
              _createElementVNode("div", _hoisted_37, [
                (_unref(controle).erro == null && _unref(controle).status != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(controle).status), 1))
                  : _createCommentVNode("", true),
                (_unref(controle).erro != null )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(controle).erro), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_RouterLink, {
                  class: "btn btn-sm btn-secondary float-end",
                  to: '/planos'
                }, {
                  default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                    _createTextVNode("Fechar", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janSincronizar',
      tamanho: "modal-lg",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janSincronizar,
      titulo: 'Aplicar texto do Plano aos Contratos',
      onOnFechou: _cache[26] || (_cache[26] = ($event: any) => (_unref(controle).janSincronizar = false)),
      "botao-fechar": true
    }, {
      default: _withCtx(() => [
        _cache[55] || (_cache[55] = _createElementVNode("p", { class: "text-muted" }, " Selecione os contratos que devem passar a usar o texto atual do Plano. Contratos já assinados também podem ser selecionados — a assinatura do cliente e da contratada são preservadas e reaplicadas ao novo texto. ", -1)),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("a", {
            class: "btn btn-sm btn-outline-secondary me-1",
            href: "#",
            onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (marcarTodos(true)), ["prevent"]))
          }, "Marcar todos"),
          _createElementVNode("a", {
            class: "btn btn-sm btn-outline-secondary",
            href: "#",
            onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (marcarTodos(false)), ["prevent"]))
          }, "Desmarcar todos")
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("table", _hoisted_43, [
            _cache[52] || (_cache[52] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "text-center" }, "Aplicar?"),
                _createElementVNode("th", null, "Contrato"),
                _createElementVNode("th", null, "Cliente"),
                _createElementVNode("th", null, "Assinado em")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_unref(controle).contratosPlano.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [...(_cache[51] || (_cache[51] = [
                    _createElementVNode("td", {
                      colspan: "4",
                      class: "text-center"
                    }, "Nenhum contrato encontrado para este Plano", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).contratosPlano, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.contratoId
                }, [
                  _createElementVNode("td", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((_unref(controle).selecionados[item.contratoId]) = $event)
                    }, null, 8, _hoisted_46), [
                      [_vModelCheckbox, _unref(controle).selecionados[item.contratoId]]
                    ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.contratoId), 1),
                  _createElementVNode("td", null, _toDisplayString(item.cliente?.nome ?? item.empresa?.nome ?? '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(item.dataAssinatura ? _unref(fdata)(item.dataAssinatura) : 'Pendente'), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("a", {
            class: "btn btn-sm btn-success",
            href: "#",
            onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (aplicarSincronizacao()), ["prevent"]))
          }, [...(_cache[53] || (_cache[53] = [
            _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1),
            _createTextVNode(" Aplicar Selecionados ", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(controle).statusSincronizar), 1),
          _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(controle).erroSincronizar), 1)
        ]),
        (_unref(controle).resultadoSincronizar.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createElementVNode("table", _hoisted_52, [
                _cache[54] || (_cache[54] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Contrato"),
                    _createElementVNode("th", null, "Resultado")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).resultadoSincronizar, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.contratoId
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.contratoId), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass(item.sucesso ? 'text-success' : 'text-danger')
                      }, _toDisplayString(item.mensagem), 3)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})